
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91id_93mXPKasK6E5Meta } from "/application/src/pages/admin/[crud]/[id].vue?macro=true";
import { default as indexFlRWh0WzapMeta } from "/application/src/pages/admin/[crud]/index.vue?macro=true";
import { default as configE2ddbekiL3Meta } from "/application/src/pages/admin/config.vue?macro=true";
import { default as indexmtDa4f5gx4Meta } from "/application/src/pages/admin/index.vue?macro=true";
import { default as logino5f1fdhFwkMeta } from "/application/src/pages/auth/login.vue?macro=true";
import { default as profileXNwGBfK3maMeta } from "/application/src/pages/auth/profile.vue?macro=true";
import { default as index7UNFOtwilBMeta } from "/application/src/pages/details/index.vue?macro=true";
import { default as indexYChZYziMWcMeta } from "/application/src/pages/search/index.vue?macro=true";
export default [
  {
    name: "admin-crud-id",
    path: "/admin/:crud()/:id()",
    component: () => import("/application/src/pages/admin/[crud]/[id].vue")
  },
  {
    name: "admin-crud",
    path: "/admin/:crud()",
    component: () => import("/application/src/pages/admin/[crud]/index.vue")
  },
  {
    name: "admin-config",
    path: "/admin/config",
    component: () => import("/application/src/pages/admin/config.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/application/src/pages/admin/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/application/src/pages/auth/login.vue")
  },
  {
    name: "auth-profile",
    path: "/auth/profile",
    component: () => import("/application/src/pages/auth/profile.vue")
  },
  {
    name: "details",
    path: "/details",
    component: () => import("/application/src/pages/details/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/application/src/pages/search/index.vue")
  }
]